import { call, put } from "typed-redux-saga";
import {
  ErrorMessage,
  ErrorMessageManager,
} from "../../core/http/ErrorMessageManager";
import { Logger } from "../../core/logger";
import { MaintenanceInfo } from "../app";
import { takeEveryFsa } from "../operations";
import { assetActions } from "./actions";

const baseDir = window.location.href.substring(
  0,
  window.location.href.indexOf("/#/"),
);

export function* assetSaga() {
  yield takeEveryFsa(assetActions.fetchMessages.started, function* (action) {
    const messages: Record<string, ErrorMessage> = yield call(async () => {
      try {
        const result = await fetch(baseDir + "/assets/json/messages.json");
        const json: Record<string, ErrorMessage> = await result.json();

        return json;
      } catch (e) {
        Logger.getInstance().error(`Fetch message error`);
      }
    });

    if (messages) {
      ErrorMessageManager.Instance.setErrorMessage(messages);
    }
  });

  yield takeEveryFsa(assetActions.fetchSettings.started, function* (action) {
    const settings: { show_sms: number } = yield call(async () => {
      try {
        const result = await fetch(baseDir + "/setting.json");
        const json: { show_sms: number } = await result.json();

        return json;
      } catch (e) {
        Logger.getInstance().error(`Fetch setting error`);
      }
    });

    yield put(
      assetActions.fetchSettings.done({
        params: {},
        result: { showSms: settings.show_sms === 0 },
      }),
    );
  });

  yield takeEveryFsa(
    assetActions.fetchMaintenance.started,
    function* (actions) {
      const maintenanceInfo: MaintenanceInfo = yield call(async () => {
        try {
          const result = await fetch(baseDir + "/data/maintenance.json");
          const json: MaintenanceInfo = await result.json();
          return json;
        } catch (e) {
          Logger.getInstance().error(`Fetch maintenance info error`);
        }
      });

      yield put(
        assetActions.fetchMaintenance.done({
          params: actions.payload,
          result: maintenanceInfo,
        }),
      );
    },
  );
}
